import React from "react";
import { createRoot } from "react-dom/client";
import { initializeOffice } from "../office/ready";
import AppRouter from "../routes/Router";
import { Provider } from "react-redux";
import { store } from "../store";
import { installSignInDialog } from "../auth/signInDialog";

const container = document.getElementById("container");
const root = createRoot(container!);

const render = () => {
  root.render(
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );
};

installSignInDialog();

initializeOffice(() => {
  render();
});

// Enable Hot Module Replacement
if ((module as any).hot) {
  (module as any).hot.accept("../routes/Router", render);
}
